<template>
    <div>
        <transition name="simple-fade" mode="out-in">
            <div v-if="!matching">
                <div class="d-flex mt-4">
                    <span class="mr-2">
                        <i class="fa fa-fw fa-calendar-o"></i>
                    </span>
                    <v-date-picker
                        popover-align="right"
                        mode="range"
                        v-model="interval"
                    ></v-date-picker>
                </div>
                <div class="row mt-3">
                    <div class="col-9">
                        <div class="row" style="font-size:1.25rem">
                            <div class="col-6"><p>Client Without Staff</p></div>
                            <div class="col-6"><p>Staff Suggestions</p></div>
                        </div>
                    </div>
                    <div class="col-3"></div>
                </div>
                <div class="row w-100" v-for="c in clients">
                    <div class="col-10">
                        <div class="row bg-white w-100 match-card my-1">
                            <div class="col-6">
                                <div class="row">
                                    <div class="col-4 pr-0">
                                        <img
                                            class="img-fluid rounded-circle profile-image mt-2"
                                            :src="
                                                c && c.hasOwnProperty('picture')
                                                    ? c.picture.thumbnail
                                                    : '../../images/default_user.jpeg'
                                            "
                                        />
                                    </div>
                                    <div class="col-8 pl-0">
                                        <p class="text-capitalize mb-0">
                                            {{ c.name.first }} {{ c.name.last }},
                                        </p>
                                        <p class="mb-0">
                                            <small class="text-muted"
                                                >Autism Spectrum Disorder</small
                                            >
                                        </p>
                                        <p class="mb-0">
                                            <small class="text-muted">8-2 School ABA Shadow</small>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="row" v-for="(t, i) in therapists" v-if="i <= 3">
                                    <div class="col-1 pr-0">
                                        <div class="form-check h-100 d-flex align-items-center">
                                            <input type="checkbox" class="form-check-input check" />
                                        </div>
                                    </div>
                                    <div class="col-4 pr-0">
                                        <img
                                            class="img-fluid rounded-circle profile-image mt-2"
                                            :src="
                                                t && t.hasOwnProperty('picture')
                                                    ? t.picture.thumbnail
                                                    : '../../images/default_user.jpeg'
                                            "
                                        />
                                    </div>
                                    <div class="col-7 pl-0">
                                        <p class="text-capitalize mb-0">
                                            {{ t.name.first }} {{ t.name.last }},
                                        </p>
                                        <p class="mb-0">
                                            <small class="text-muted">3.6 miles away</small>
                                        </p>
                                        <p class="mb-0">
                                            <small class="text-muted"
                                                >1x subbed for this client</small
                                            >
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="my-1" @click="matching = true">
                            <a
                                class="btn btn-sm btn-primary text-white font-weight-bold text-uppercase"
                                >Match</a
                            >
                        </div>
                        <div class="my-1">
                            <a class="btn btn-sm bg-dark text-white text-uppercase"
                                >Send Cancellation</a
                            >
                        </div>
                    </div>
                </div>
            </div>
            <div v-else="">
                <div class="row mt-3" style="font-size:1.25rem">
                    <div class="col-12">
                        <p>Send Matched Messages</p>
                        <small
                            @click="matching = false"
                            class="text-primary font-weight-bold text-uppercase cursor-pointer"
                            >< Back to replacement list</small
                        >
                    </div>
                </div>

                <div class="row bg-white w-100 match-card mt-3">
                    <div class="col-12 col-md-5">
                        <div class="row p-2">
                            <div class="col-4 pr-0">
                                <img
                                    class="img-fluid rounded-circle profile-image mt-2"
                                    :src="
                                        c && clients[0].hasOwnProperty('picture')
                                            ? clients[0].picture.thumbnail
                                            : '../../images/default_user.jpeg'
                                    "
                                />
                            </div>
                            <div class="col-8 pl-0">
                                <p class="text-capitalize mb-0">
                                    {{ clients[0].name.first }} {{ clients[0].name.last }},
                                </p>
                                <p class="mb-0">
                                    <small class="text-muted">Autism Spectrum Disorder</small>
                                </p>
                                <p class="mb-0">
                                    <small class="text-muted">8-2 School ABA Shadow</small>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-2">
                        <p class="text-primary font-weight-bold p-3 text-center">
                            MATCHING<br />in<br />PROGRESS
                        </p>
                    </div>
                    <div class="col-12 col-md -5">
                        <div class="row">
                            <div class="col-4 pr-0">
                                <img
                                    class="img-fluid rounded-circle profile-image mt-2"
                                    :src="
                                        therapists[0] && therapists[0].hasOwnProperty('picture')
                                            ? therapists[0].picture.thumbnail
                                            : '../../images/default_user.jpeg'
                                    "
                                />
                            </div>
                            <div class="col-8 pl-0">
                                <p class="text-capitalize mb-0">
                                    {{ therapists[0].name.first }} {{ therapists[0].name.last }},
                                </p>
                                <p class="mb-0"><small class="text-muted">3.6 miles away</small></p>
                                <p class="mb-0">
                                    <small class="text-muted">1x subbed for this client</small>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-8 offset-md-2">
                    <div class="mt-3" style="font-size:1.25rem">
                        <p>Message to Team</p>
                    </div>
                    <textarea
                        class="form-control mb-2"
                        name="homework"
                        id="homework"
                        rows="5"
                        placeholder="Your message"
                    ></textarea>
                    <div class="row">
                        <div class="col-6 pr-0">
                            <div class="form-check" v-for="t in therapists">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="defaultCheck1"
                                />
                                <label class="form-check-label text-capitalize" for="defaultCheck1">
                                    {{ t.name.first }} {{ t.name.last }}
                                </label>
                            </div>
                        </div>
                        <div class="col-6 pl-0">
                            <div class="my-1" @click="matching = true">
                                <a
                                    class="btn btn-sm btn-primary text-white font-weight-bold text-uppercase"
                                    >Send message</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "ScheduleReplacement",
    data() {
        return {
            matching: false,
            apiT: `https://randomuser.me/api/?results=10&gender=female&nat=us`,
            apiC: `https://randomuser.me/api/?results=5&gender=female&nat=us`,
            therapists: null,
            clients: null,
            interval: {
                start: new Date(),
                end: new Date(),
            },
        };
    },
    created() {
        this.interval.end.setDate(this.interval.start.getDate() + 7);
        this.fetchTherapists();
        this.fetchClients();
    },
    methods: {
        fetchTherapists() {
            axios.get(this.apiT).then(r => {
                this.therapists = r.data.results;
            });
        },
        fetchClients() {
            axios.get(this.apiC).then(r => {
                this.clients = r.data.results;
            });
        },
        detailsUser(user) {
            this.user = user;
        },
    },
};
</script>

<style scoped lang="scss">
.match-card {
    border: solid 1px #8f8f8f;
}
.profile-image {
    min-width: 3rem;
    max-width: 3rem;
    min-height: 3rem;
    max-height: 3rem;
}
</style>
